(function() {

    angular
    .module('meanApp')
    .service('colors', colors);
  
    colors.$inject = ['$rootScope'];
    function colors ($rootScope) {
        
        var allColorsAvailableForBackGround = ['#462c2c', '#d9b826', '#de994a', '#de6f4a', '#c34a32','#bd637a', '#ce85b6',
'#a375b3', '#8073bf', '#5b6696',  '#5176a7', '#449cad','#318c75','#27986c', '#279847','#a27d4a', '#b37e57'];

        var hexToHSL = function (H) {
            // Convert hex to RGB first
            var r = 0, g = 0, b = 0;
            if (H.length == 4) {
            r = "0x" + H[1] + H[1];
            g = "0x" + H[2] + H[2];
            b = "0x" + H[3] + H[3];
            } else if (H.length == 7) {
            r = "0x" + H[1] + H[2];
            g = "0x" + H[3] + H[4];
            b = "0x" + H[5] + H[6];
            }
            // Then to HSL
            r /= 255;
            g /= 255;
            b /= 255;
            var cmin = Math.min(r,g,b),
                cmax = Math.max(r,g,b),
                delta = cmax - cmin,
                h = 0,
                s = 0,
                l = 0;
        
            if (delta == 0)
            h = 0;
            else if (cmax == r)
            h = ((g - b) / delta) % 6;
            else if (cmax == g)
            h = (b - r) / delta + 2;
            else
            h = (r - g) / delta + 4;
        
            h = Math.round(h * 60);
        
            if (h < 0)
            h += 360;
        
            l = (cmax + cmin) / 2;
            s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
            s = +(s * 100).toFixed(1);
            l = +(l * 100).toFixed(1);
        
            //return "hsl(" + h + "," + 40 + "%," + 50 + "%)";
            return {
                'h' : h,
                's' : s,
                'l' : l
            };
        };

        this.hexToHSLLighter = function(hexColor, lightness) {
            var hsl = hexToHSL(hexColor);
            return "hsl(" + hsl['h'] + "," + 40 + "%," + lightness + "%)";
        };

        this.getClosestColorPossible = function(hexDominantColor) {
            if(!this._hueToColorMapping) {
                this._hueToColorMapping = {};
                allColorsAvailableForBackGround.forEach(function(hexColor) {
                    this._hueToColorMapping[hexToHSL(hexColor).h] = hexColor;
                }.bind(this));
            }
            var hueDominantColor = hexToHSL(hexDominantColor).h,
            closestKey = '',
            minDist = 1000; //arbitrary distance
        
            Object.keys(this._hueToColorMapping).forEach(function(hueKey) {
                if (Math.abs(parseInt(hueDominantColor) - parseInt(hueKey)) < minDist) {
                    closestKey = hueKey;
                    minDist = Math.abs(parseInt(hueDominantColor) - parseInt(hueKey));
                }
            });
        
            return this._hueToColorMapping[closestKey];
        }

        return this;    
    }
  
  })();

